"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatchFooterEvent = void 0;

var _analyticsEvents = require("@creditas-lab/analytics-events");

var dispatchFooterEvent = function dispatchFooterEvent(_ref) {
  var category = _ref.category,
      eventData = _objectWithoutProperties(_ref, ["category"]);

  var contextCategory = category ? " ".concat(category) : '';
  var eventCategory = "creditas | footer".concat(contextCategory);
  (0, _analyticsEvents.dispatchEvent)(_objectSpread({
    event: 'gaCreditasEvent',
    category: eventCategory
  }, eventData));
};

exports.dispatchFooterEvent = dispatchFooterEvent;